import { useMemo } from 'react';
import { useCountryConfig } from '../../../hooks/use-country-config';
import { CountryConfigNames } from '../../../contexts/country-config-context/country-config-enums';

export const useTopMarketplaces = () => {
  const [topMarketplacesEnabled, topMarketplacesData] = useCountryConfig(CountryConfigNames.TopMarketplaces);

  return useMemo(() => {
    if (!topMarketplacesEnabled || !topMarketplacesData) {
      return [];
    }

    const topMarketplaces = topMarketplacesData?.topMarketplacesList.split(',').map((marketplaceId) => parseInt(marketplaceId, 10)) || [];
    return topMarketplaces;
  }, [topMarketplacesEnabled, topMarketplacesData]);
};
